import React from 'react';
export function MechanismSection() {
  return <section id="como-funciona" className="py-6 md:py-9 px-5 bg-[radial-gradient(ellipse_at_bottom_left,rgba(0,102,255,0.15)_0%,transparent_60%),linear-gradient(180deg,var(--dark-bg),var(--card-bg))]" data-id="element-85" data-mp="322cflnuta330">
      <div className="max-w-[900px] mx-auto" data-id="element-86" data-mp="cfgdgdiahd7p">
        <span className="inline-block font-heading font-bold text-[0.75rem] tracking-[3px] uppercase text-magenta-bright mb-2" data-id="element-87" data-mp="8d3atxyu9vf5">
          El mecanismo
        </span>

        <h2 className="text-[clamp(1.6rem,4vw,2.5rem)] font-heading font-black leading-[1.15] mb-3" data-id="element-88" data-mp="103hkfhztkll0">
          Así funciona el
          <br data-id="element-89" data-mp="vbg0d9wetqkf" />
          <span className="text-gradient-blue" data-id="element-90" data-mp="vay5ohpebkem">Ciclo P-C-V</span> —<br data-id="element-91" data-mp="rb5x45005e99" />y cómo
          se interrumpe
        </h2>

        <div className="flex flex-col md:flex-row items-center justify-center gap-0 my-4 flex-wrap" data-id="element-92" data-mp="ranrwivd3pp7">
          {/* Node 1: Placer */}
          <div className="text-center py-4 px-4 rounded-2xl flex-1 min-w-[140px] max-w-[200px] bg-gradient-to-br from-[rgba(255,165,0,0.2)] to-[rgba(255,215,0,0.1)] border-2 border-[rgba(255,165,0,0.5)]" data-id="element-93" data-mp="1j2bx8lfq3byj">
            <div className="text-[2.5rem] mb-[10px]" data-id="element-94" data-mp="cplgrlvsova4">✨</div>
            <div className="font-heading font-black text-[1.3rem] mb-2 text-gold" data-id="element-95" data-mp="cr4xfdld58cf">
              PLACER
            </div>
            <div className="text-[0.85rem] text-white/65 leading-[1.5]" data-id="element-96" data-mp="2z8xdwzpv85k">
              El cerebro busca aliviar el vacío con una recompensa inmediata
            </div>
          </div>

          <div className="text-[2rem] text-white/25 py-[5px] md:px-[10px] shrink-0 rotate-90 md:rotate-0" data-id="element-97" data-mp="3l786nns4j52v">
            →
          </div>

          {/* Node 2: Culpa */}
          <div className="text-center py-4 px-4 rounded-2xl flex-1 min-w-[140px] max-w-[200px] bg-gradient-to-br from-[rgba(194,0,111,0.2)] to-[rgba(107,0,182,0.1)] border-2 border-[rgba(194,0,111,0.5)]" data-id="element-98" data-mp="3b88vnyjvyxcp">
            <div className="text-[2.5rem] mb-[10px]" data-id="element-99" data-mp="19fuj7f042l3o">⚡</div>
            <div className="font-heading font-black text-[1.3rem] mb-2 text-magenta-bright" data-id="element-100" data-mp="1eexj6l18i14s">
              CULPA
            </div>
            <div className="text-[0.85rem] text-white/65 leading-[1.5]" data-id="element-101" data-mp="1cytknq19ljb8">
              La vergüenza no sana — vacía más. Y un vacío más profundo necesita
              más placer
            </div>
          </div>

          <div className="text-[2rem] text-white/25 py-[5px] md:px-[10px] shrink-0 rotate-90 md:rotate-0" data-id="element-102" data-mp="12zcfratu79gb">
            →
          </div>

          {/* Node 3: Vacío */}
          <div className="text-center py-4 px-4 rounded-2xl flex-1 min-w-[140px] max-w-[200px] bg-gradient-to-br from-[rgba(0,102,255,0.2)] to-[rgba(0,207,255,0.1)] border-2 border-[rgba(0,102,255,0.5)]" data-id="element-103" data-mp="1vmoskta742wf">
            <div className="text-[2.5rem] mb-[10px]" data-id="element-104" data-mp="1lwm14xiq2x07">🌀</div>
            <div className="font-heading font-black text-[1.3rem] mb-2 text-blue-light" data-id="element-105" data-mp="1hwl9ucaiyrbq">
              VACÍO
            </div>
            <div className="text-[0.85rem] text-white/65 leading-[1.5]" data-id="element-106" data-mp="2ef9grxey9jtw">
              La tensión interna sin resolver alimenta el siguiente impulso
            </div>
          </div>

          <div className="text-[2rem] text-white/25 py-[5px] md:px-[10px] shrink-0 rotate-90 md:rotate-0" data-id="element-107" data-mp="3sasmog9fzern">
            ↩
          </div>
        </div>

        <div className="bg-gradient-to-br from-[rgba(107,0,182,0.25)] to-[rgba(194,0,111,0.15)] border border-[rgba(107,0,182,0.5)] rounded-2xl p-5 mt-3" data-id="element-108" data-mp="147zx8qf6t0f">
          <h3 className="text-[1.25rem] font-heading font-bold text-gold mb-2" data-id="element-109" data-mp="a4wf46rjuzew">
            🔑 La razón real por la que no puedes parar
          </h3>
          <div className="text-[1rem] leading-[1.6] text-white/85 space-y-2" data-id="element-110" data-mp="f1mt8ojsnkxo">
            <p data-id="element-111" data-mp="k196gxzmh16h">
              Tu cerebro no busca el placer porque seas débil. Lo busca porque
              en algún punto aprendió que el placer{' '}
              <strong data-id="element-112" data-mp="svnnb4zswjrp">tapa el vacío.</strong> Una tensión interna sin nombre,
              que la conducta interrumpe temporalmente.
            </p>
            <p data-id="element-113" data-mp="xw1w4p987xqs">
              El problema es lo que viene después: la culpa. La culpa no te sana
              — <strong data-id="element-114" data-mp="12tladp5xcaiq">te vacía más.</strong> Genera una versión más profunda
              del vacío original. Y un vacío más profundo necesita más placer
              para taparlo.
            </p>
            <p className="text-gold font-bold" data-id="element-115" data-mp="k788ft2mzcmr">
              PLACER, CULPA Y VACÍO interrumpe ese bucle desde adentro — con
              prácticas diarias específicas para cada punto del ciclo.
            </p>
          </div>
        </div>
      </div>
    </section>;
}